import { render } from "./DashboardRedZonesCard.vue?vue&type=template&id=30e27815&scoped=true"
import script from "./DashboardRedZonesCard.vue?vue&type=script&lang=js"
export * from "./DashboardRedZonesCard.vue?vue&type=script&lang=js"

import "./DashboardRedZonesCard.vue?vue&type=style&index=0&id=30e27815&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e27815"]])

export default __exports__